import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ObjectDisposedError } from "./Error";
import { createNoDashGuid } from "./Guid";
export var EventSource = /*#__PURE__*/function () {
  function EventSource(metadata) {
    var _this = this;

    _classCallCheck(this, EventSource);

    this.privEventListeners = {};
    this.privIsDisposed = false;

    this.onEvent = function (event) {
      if (_this.isDisposed()) {
        throw new ObjectDisposedError("EventSource");
      }

      if (_this.metadata) {
        for (var paramName in _this.metadata) {
          if (paramName) {
            if (event.metadata) {
              if (!event.metadata[paramName]) {
                event.metadata[paramName] = _this.metadata[paramName];
              }
            }
          }
        }
      }

      for (var eventId in _this.privEventListeners) {
        if (eventId && _this.privEventListeners[eventId]) {
          _this.privEventListeners[eventId](event);
        }
      }
    };

    this.attach = function (onEventCallback) {
      var id = createNoDashGuid();
      _this.privEventListeners[id] = onEventCallback;
      return {
        detach: function detach() {
          delete _this.privEventListeners[id];
        }
      };
    };

    this.attachListener = function (listener) {
      return _this.attach(listener.onEvent);
    };

    this.isDisposed = function () {
      return _this.privIsDisposed;
    };

    this.dispose = function () {
      _this.privEventListeners = null;
      _this.privIsDisposed = true;
    };

    this.privMetadata = metadata;
  }

  _createClass(EventSource, [{
    key: "metadata",
    get: function get() {
      return this.privMetadata;
    }
  }]);

  return EventSource;
}();